// World 6 (Prism) — second paid-tier world. Builds directly on W5's depth curve
// by stepping the floor up one notch: W5 opens at d=5, W6 opens at d=6, and
// climaxes at d=7 (same ceiling as W5-b). The "Prism" placeholder originally
// teased prismatic/splitter tiles; without that mechanic in the engine yet,
// the character comes from dense r=3 lattices (tileCount 12-14) and 5-6 color
// palettes that force longer chains and more "which cluster do I commit to"
// reads than W5. Ships as a single 10-level pack from tools/generate-world6.mjs.
// A "-b" continuation may follow once W7-W10 have shipped.
import type { LevelDef } from '@tessera/engine';
import { WORLD_6_GENERATED } from './world6-generated';

export const WORLD_6_LEVELS: LevelDef[] = [...WORLD_6_GENERATED];
